import React from 'react';

function NotasError() {
  return <p>Desespérate, hubo un error...</p>;
}

export { NotasError };

